module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "chapter-name"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ul', {
    staticClass: "sgc-1"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Flow_0_0004#qIntroduction-by-Anthony-Arnove3"
    }
  }, [_vm._v("Introduction by Anthony Arnove")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Flow_0_0005#qNote-on-the-text15"
    }
  }, [_vm._v("Note on the text")])])]), _vm._v(" "), _c('ol', {
    staticClass: "sgc-1"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Flow_0_0006#qSouthern-Influence-in-National-Politics16"
    }
  }, [_vm._v("Southern Influence in National Politics")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Flow_0_0007#qSpeech-against-the-Vietnam-War-on-Boston-C46"
    }
  }, [_vm._v("Speech against the Vietnam War on Boston C")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Flow_0_0008#qThinking-about-Vietnam--Political-Theory-a60"
    }
  }, [_vm._v("Thinking about Vietnam: Political Theory a")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0009#qAcademic-Freedom--Collaboration-and-Resist129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Academic Freedom: Collaboration and Resist")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0010#qSecond-Thoughts-on-the-First-Amendment184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Thoughts on the First Amendment")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0011#q1492-1992--The-Legacy-of-Columbus210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1492–1992: The Legacy of Columbus")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0012#qA-People-s-History-of-the-United-States237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A People’s History of the United States")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0013#qA-Call-to-Action--Abolish-the-Death-Penalt281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Call to Action: Abolish the Death Penalty")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0014#qThe-Case-of-Sacco-and-Vanzetti297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Case of Sacco and Vanzetti")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0015#qEmma-Goldman--Anarchism--and-War-Resistanc319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emma Goldman, Anarchism, and War Resistance")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0016#qConfronting-Government-Lies332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confronting Government Lies")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0017#qHistory-Matters375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History Matters")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0018#qThe-Myth-of-American-Exceptionalism391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Myth of American Exceptionalism")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0019#qJust-War431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just War")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0020#qOvercoming-Obstacles526",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overcoming Obstacles")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0021#qCivil-Disobedience-in-the-Twenty-First-Cen572",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil Disobedience in the Twenty-First Cen")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0022#qThe-State-of-the-Union616",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The State of the Union")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0023#qStanding-Up-for-Justice-in-the-Age-of-Obam664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standing Up for Justice in the Age of Obam")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0024#qTalk-on-Democracy-and-Citizenship-in-Greec732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk on Democracy and Citizenship in Greece")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0025#qThree-Holy-Wars764",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Holy Wars")])])]), _vm._v(" "), _c('ul', {
    staticClass: "sgc-1"
  }, [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0026#qAcknowledgments813",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#qAbout-Howard-Zinn814",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Howard Zinn")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0027#qAbout-Anthony-Arnove818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Anthony Arnove")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Flow_0_0028#qBooks-by-Howard-Zinn819",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books by Howard Zinn")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0